import React, { useEffect } from "react";
import { connect  } from "react-redux";
import ProfileTabs from "./components/ProfileTabs";
import ProfileHeader from "./components/ProfileHeader";
import { getMyJobApplicantList } from "../../../redux/jobapplicant/jobApplicantState";

const MyProfile = ({doSearch, pagination}) => {

  useEffect(() => {
	    doSearch({paginate: pagination.per_page});
    }, [doSearch, pagination.per_page]);
    
  return (
    <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-4">
      <ProfileHeader />

      <ProfileTabs/>
    </div>
  );
};

const mapStateToProps = (state) => ({
  recordList: state.jobApplicant.jobApplicantList?.items,
  requesting: state.jobApplicant.jobApplicantList.requesting,
  error: state.jobApplicant.jobApplicantList.error,
  pagination: state.jobApplicant.jobApplicantList?.pagination,
  filters: state.jobApplicant.jobApplicantList?.filters,
});

const mapDispatchToProps = (dispatch) => ({
  doSearch: (filters) => dispatch(getMyJobApplicantList(filters)),
});

export default connect(mapStateToProps, mapDispatchToProps)(MyProfile);